module.exports = __webpack_public_path__ + "assets/Secant2Detailed.11c59ea419bf2df28d7f6ff6470c5708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Secant2Detailed.png
// module id = 557
// module chunks = 0